import $ from 'jquery'

;(function () {
    var $pairPopup = null
    var $childrenPopup = null
    var debounceTimer = null

    function escapeHtml(text) {
        var el = document.createElement('span')
        el.textContent = text
        return el.innerHTML.replace(/"/g, '&quot;')
    }

    function positionPopup($popup, $trigger) {
        var offset = $trigger.offset()
        $popup.css({
            top: offset.top + $trigger.outerHeight() + 4,
            left: offset.left
        }).show()
        $popup.data('trigger', $trigger)
    }

    function closeAll() {
        clearTimeout(debounceTimer)
        if ($pairPopup) $pairPopup.hide().removeData('trigger')
        if ($childrenPopup) $childrenPopup.hide().removeData('trigger')
    }

    function isSameTrigger($popup, $trigger, key) {
        var current = $popup && $popup.is(':visible') && $popup.data('trigger')
        return current && current.data(key) === $trigger.data(key)
    }

    // --- Pair popup ---

    $(document).on('click', '.phrase-cluster-trigger', function (e) {
        e.stopPropagation()
        var $trigger = $(this)

        if (isSameTrigger($pairPopup, $trigger, 'child-id')) {
            closeAll()
            return
        }

        closeAll()

        if (!$pairPopup) {
            $pairPopup = $(
                '<div class="phrase-popup">' +
                '<input type="text" class="form-control input-sm" placeholder="Hledat fr\u00E1zi...">' +
                '<ul class="phrase-popup-results"></ul>' +
                '</div>'
            ).appendTo('body')
        }

        positionPopup($pairPopup, $trigger)
        $pairPopup.find('input').val('').focus()
        $pairPopup.find('.phrase-popup-results').empty().hide()
    })

    $(document).on('input', '.phrase-popup input', function () {
        var query = this.value.trim()
        var $results = $pairPopup.find('.phrase-popup-results')
        var $trigger = $pairPopup.data('trigger')

        clearTimeout(debounceTimer)

        if (query.length < 2) {
            $results.hide().empty()
            return
        }

        debounceTimer = setTimeout(function () {
            var url = $trigger.data('autocomplete-url').replace('__QUERY__', encodeURIComponent(query))

            $.get(url, function (data) {
                if (!data.length) {
                    $results.html('<li class="phrase-popup-empty">Nic nenalezeno</li>').show()
                    return
                }

                $results.html(data.map(function (item) {
                    return '<li data-id="' + item.id + '">' + escapeHtml(item.phrase) + '</li>'
                }).join('')).show()
            })
        }, 300)
    })

    $(document).on('click', '.phrase-popup-results li:not(.phrase-popup-empty)', function (e) {
        e.stopPropagation()
        var $trigger = $pairPopup.data('trigger')
        var url = $trigger.data('pair-url').replace(/parentId=0/, 'parentId=' + this.dataset.id)
        $.nette.ajax({ url: url })
        closeAll()
    })

    // --- Children popup ---

    $(document).on('click', '.phrase-cluster-toggler', function (e) {
        e.stopPropagation()
        var $trigger = $(this)

        if (isSameTrigger($childrenPopup, $trigger, 'children-url')) {
            closeAll()
            return
        }

        closeAll()

        if (!$childrenPopup) {
            $childrenPopup = $(
                '<div class="phrase-popup phrase-popup--children">' +
                '<table class="table table-striped" style="margin: 0; font-size: 12px">' +
                '<thead><tr><th>Fr\u00E1ze</th><th class="text-center">Naposledy</th><th class="text-center">T\u00FDden</th><th class="text-center">M\u011Bs\u00EDc</th><th class="text-center">Celkem</th><th></th></tr></thead>' +
                '<tbody></tbody></table></div>'
            ).appendTo('body')
        }

        var $tbody = $childrenPopup.find('tbody')
        $tbody.html('<tr><td colspan="6" class="text-muted">Na\u010D\u00EDt\u00E1m...</td></tr>')
        positionPopup($childrenPopup, $trigger)

        $.get($trigger.data('children-url'), function (data) {
            $tbody.html(data.map(function (item) {
                return '<tr>' +
                    '<td><a href="' + item.editUrl + '" class="phrase-cluster-phrase" title="' + escapeHtml(item.phrase) + '">' + escapeHtml(item.phrase) + '</a></td>' +
                    '<td class="text-center">' + escapeHtml(item.lastSearch) + '</td>' +
                    '<td class="text-center">' + item.searchCountWeek + '</td>' +
                    '<td class="text-center">' + item.searchCountMonth + '</td>' +
                    '<td class="text-center">' + item.searchCount + '</td>' +
                    '<td><a href="' + item.previewUrl + '" target="_blank" class="btn btn-default btn-xs" title="Preview"><i class="fa fa-search"></i></a></td>' +
                    '</tr>'
            }).join(''))
        })
    })

    // --- Close on outside click ---

    $(document).on('click', '.phrase-popup', function (e) {
        e.stopPropagation()
    })

    $(document).on('click', closeAll)
})()
